import * as React from "react";
export const DesktopLogo = () => {
    return React.createElement("img", { className: "h-8 w-8 transition-all group-hover:scale-110", src: "/favicon-32x32.png" });
};
export const MobileLogo = () => {
    return React.createElement("img", { className: "h-8 w-8 transition-all group-hover:scale-110", src: "/favicon-32x32.png" });
};
//# sourceMappingURL=Logo.js.map